import { QueryKeys } from 'queries/types'

const ROOT = 'work'

export const workKeys = {
  root: [ROOT],
  breaks: (workId: number) => [ROOT, 'breaks', workId],
} satisfies QueryKeys
